import { FC, memo } from 'react';
import { AppAutocomplete } from '../../../../../common/components';
import { AppAutocompleteComponentProps } from '../../../../../common/interfaces';
import { parseSelectData } from '../../../../../common/utils';
import { useAutocompleteCloudflareAccountsQuery } from '../../queries';


interface Props extends AppAutocompleteComponentProps {}

export const CloudflareAccountsAllAutocomplete: FC<Props> = memo(({ ...props }) => {
  return (
    <AppAutocomplete<typeof useAutocompleteCloudflareAccountsQuery>
      { ...props }
      options={
        (data) =>
          parseSelectData(data, {
            value: 'id',
            label: 'email'
          })
      }
      notFoundDescription={ 'Немає акаунтів Cloudflare провайдера' }
      placeholder={ 'Знайдіть акаунт Cloudflare провайдера' }
      query={ useAutocompleteCloudflareAccountsQuery }
    />
  );
});
